<script lang="ts">
	import { getClient, mutate } from 'svelte-apollo';
	import Dialog, { Title, Content, Actions } from '@smui/dialog/styled';
	import { availableClients, userInfo } from '../stores';
	import Text from '../components/Text.svelte';
	import Button from '../components/Button.svelte';
	import LoadingOverlay from '../components/LoadingOverlay.svelte';
	import { changeClientMutation } from '../graphql/queries/clients';

	let dialogChoose = false;
	let dialogSuccess = false;
	let dialogFail = false;
	let isLoading = '';

	const client = getClient();

	const changeAction = async (clientId: number) => {
		dialogChoose = false;
		isLoading = "Changing user's current client";

		mutate(client, {
			mutation: changeClientMutation,
			variables: {
				clientId
			},
			errorPolicy: 'all'
		})
			.then(({ data }) => {
				console.log('ok, data', data);
				dialogSuccess = true;
				onSuccessDialogClose();
			})
			.catch((e) => {
				console.error('error: ', e);
				dialogFail = true;
			})
			.finally(() => {
				isLoading = '';
			});
	};

	function onSuccessDialogClose() {
		isLoading = 'Restarting application. Please wait ...';
		setTimeout(() => {
			window.location.reload();
		}, 700);
	}
</script>

<!-- <slot> -->
<Text type="body1">
	Client:
	<b>{$userInfo.client.name}</b>
</Text>
{#if $availableClients.length > 1}
	<Button variant="raised" on:click={() => (dialogChoose = true)}>Change</Button>
{/if}
<!-- </slot> -->

<LoadingOverlay spinner visible={isLoading !== ''} title={isLoading} />

<Dialog
	open={dialogChoose}
	aria-labelledby="dialog-choose-title"
	aria-describedby="dialog-choose-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-choose-title">Application active client</Title>
	<Content id="dialog-choose-content">
		Choose one of following clients
		<br />
		<ul>
			{#each $availableClients as clientItem}
				<li>
					<div>
						<Button on:click={() => changeAction(clientItem.id)}>{clientItem.name}</Button>
						{#if clientItem.id === $userInfo.client.id}(current client){/if}
					</div>
				</li>
			{/each}
		</ul>
	</Content>

	<Actions>
		<Button on:click={() => (dialogChoose = false)}>Cancel</Button>
	</Actions>
</Dialog>

<Dialog
	on:MDCDialog:closed={onSuccessDialogClose}
	open={dialogSuccess}
	aria-labelledby="dialog-success-title"
	aria-describedby="dialog-success-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-success-title">Client changed succesfully</Title>
	<Content id="dialog-success-content">
		Application will restart by closing this pop-up
		<br />
	</Content>

	<Actions>
		<Button on:click={() => (dialogSuccess = false)}>Restart app</Button>
	</Actions>
</Dialog>

<Dialog
	open={dialogFail}
	aria-labelledby="dialog-fail-title"
	aria-describedby="dialog-fail-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-fail-title">Change client error</Title>
	<Content id="dialog-fail-content">
		There was an error during changing user's current client. Please try again or contact
		administrator
		<br />
	</Content>

	<Actions>
		<Button on:click={() => (dialogFail = false)}>Close</Button>
	</Actions>
</Dialog>

<style>
	b {
		margin-right: 16px;
	}
</style>
